import RelatedDetail from '../_detail';

// 関連サイト詳細(JA)。本文・画像は src/data/related/butler-bell.ts、FAQ は src/data/faq.json(/related/butler-bell)。
export default function RelatedButlerBellPage() {
  return <RelatedDetail slug="butler-bell" lang="ja" />;
}
